import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma } from './JsonExceptions.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull_getInstancehlive1cpt4pr as JsonNull_getInstance,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
} from '../JsonElement.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  DeepRecursiveScope1pqaydvh4vdcu as DeepRecursiveScope,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/DeepRecursive.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { tokenDescription3r6eqmtoxe76u as tokenDescription } from './AbstractJsonLexer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.q2s_1.u2s(6);
  if ($this.q2s_1.v2s() === 4) {
    $this.q2s_1.j2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().bc();
  $l$loop: while ($this.q2s_1.w2s()) {
    var key = $this.r2s_1 ? $this.q2s_1.y2s() : $this.q2s_1.x2s();
    $this.q2s_1.u2s(5);
    var element = $this.z2s();
    // Inline function 'kotlin.collections.set' call
    result.x4(key, element);
    lastToken = $this.q2s_1.a2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.q2s_1.j2r('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.q2s_1.u2s(7);
  } else if (lastToken === 4) {
    if (!$this.s2s_1) {
      invalidTrailingComma($this.q2s_1);
    }
    $this.q2s_1.u2s(7);
  }
  return new (JsonObject())(result);
}
function *readObject_0($this, $receiver, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.q2s_1.u2s(6);
  if ($this.q2s_1.v2s() === 4) {
    $this.q2s_1.j2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().bc();
  $l$loop: while ($this.q2s_1.w2s()) {
    var key = $this.r2s_1 ? $this.q2s_1.y2s() : $this.q2s_1.x2s();
    $this.q2s_1.u2s(5);
    var element = yield* $receiver.os(Unit_instance, $completion);
    // Inline function 'kotlin.collections.set' call
    result.x4(key, element);
    lastToken = $this.q2s_1.a2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.q2s_1.j2r('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.q2s_1.u2s(7);
  } else if (lastToken === 4) {
    if (!$this.s2s_1) {
      invalidTrailingComma($this.q2s_1);
    }
    $this.q2s_1.u2s(7);
  }
  return new (JsonObject())(result);
}
function readArray($this) {
  var lastToken = $this.q2s_1.a2t();
  if ($this.q2s_1.v2s() === 4) {
    $this.q2s_1.j2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList().p2();
  while ($this.q2s_1.w2s()) {
    var element = $this.z2s();
    result.i2(element);
    lastToken = $this.q2s_1.a2t();
    if (!(lastToken === 4)) {
      var tmp0 = $this.q2s_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.n2m_1;
      if (!condition) {
        var tmp$ret$2 = 'Expected end of the array or comma';
        tmp0.j2r(tmp$ret$2, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.q2s_1.u2s(9);
  } else if (lastToken === 4) {
    if (!$this.s2s_1) {
      invalidTrailingComma($this.q2s_1, 'array');
    }
    $this.q2s_1.u2s(9);
  }
  return new (JsonArray())(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.r2s_1 || !isString) {
    tmp = $this.q2s_1.y2s();
  } else {
    tmp = $this.q2s_1.x2s();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new (JsonLiteral())(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new (DeepRecursiveFunction())(JsonTreeReader$readDeepRecursive$slambda_0($this)), Unit_instance);
}
var JsonTreeReader$readDeepRecursive$slambdaClass;
function JsonTreeReader$readDeepRecursive$slambda() {
  if (JsonTreeReader$readDeepRecursive$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.b2t_1 = this$0;
      }
      *c2t($this$DeepRecursiveFunction, it, $completion) {
        var tmp0_subject = this.b2t_1.q2s_1.v2s();
        var tmp;
        if (tmp0_subject === 1) {
          tmp = readValue(this.b2t_1, true);
        } else if (tmp0_subject === 0) {
          tmp = readValue(this.b2t_1, false);
        } else if (tmp0_subject === 6) {
          tmp = yield* /*#__NOINLINE__*/readObject_0(this.b2t_1, $this$DeepRecursiveFunction, $completion);
        } else if (tmp0_subject === 8) {
          tmp = readArray(this.b2t_1);
        } else {
          this.b2t_1.q2s_1.j2r("Can't begin reading element, unexpected token");
        }
        return tmp;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof DeepRecursiveScope() ? p1 : THROW_CCE();
        return this.c2t(tmp, p2 instanceof Unit() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    JsonTreeReader$readDeepRecursive$slambdaClass = $;
  }
  return JsonTreeReader$readDeepRecursive$slambdaClass;
}
function JsonTreeReader$readDeepRecursive$slambda_0(this$0) {
  var i = new (JsonTreeReader$readDeepRecursive$slambda())(this$0);
  var l = ($this$DeepRecursiveFunction, it, $completion) => i.c2t($this$DeepRecursiveFunction, it, $completion);
  l.$arity = 2;
  return l;
}
var JsonTreeReaderClass;
function JsonTreeReader() {
  if (JsonTreeReaderClass === VOID) {
    class $ {
      constructor(configuration, lexer) {
        this.q2s_1 = lexer;
        this.r2s_1 = configuration.n2n_1;
        this.s2s_1 = configuration.z2n_1;
        this.t2s_1 = 0;
      }
      z2s() {
        var token = this.q2s_1.v2s();
        var tmp;
        if (token === 1) {
          tmp = readValue(this, true);
        } else if (token === 0) {
          tmp = readValue(this, false);
        } else if (token === 6) {
          var tmp_0;
          this.t2s_1 = this.t2s_1 + 1 | 0;
          if (this.t2s_1 === 200) {
            tmp_0 = readDeepRecursive(this);
          } else {
            tmp_0 = readObject(this);
          }
          var result = tmp_0;
          this.t2s_1 = this.t2s_1 - 1 | 0;
          tmp = result;
        } else if (token === 8) {
          tmp = readArray(this);
        } else {
          this.q2s_1.j2r('Cannot read Json element because of unexpected ' + tokenDescription(token));
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'JsonTreeReader', VOID, VOID, VOID, [1]);
    JsonTreeReaderClass = $;
  }
  return JsonTreeReaderClass;
}
//region block: exports
export {
  JsonTreeReader as JsonTreeReader1ycreu77eikqj,
};
//endregion

//# sourceMappingURL=JsonTreeReader.mjs.map
